import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from 'src/app/shared/services';

export const IsAdmin: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {

    const authService = inject( AuthService );
    const router      = inject( Router );
    

    if ( authService.currentUser()?.role === 'admin' || authService.currentUser()?.role === 'super' ) {
      return true;
    }
    
    router.navigate(['/app/stores/all-stores']);
    return false;
};